export default function () {
  /**
   * A type-safe slug, which is always an array of strings
   */
  const slug = computed(() => {
    const _slug = useRoute().params.slug
    return Array.isArray(_slug) ? _slug : [_slug]
  })

  /**
   * A string version of the slug
   */
  const slugString = computed(() => slug.value.join('/'))

  return { slugString }
}
